import { FRANCHISE_STORE } from '../../types.js';
import { convertToValidOpeningHours } from '../adapters/convert-to-valid-opening-hours.js';
import { getRating } from '../adapters/get-rating.js';

const fromStoreGroupQueryDataToStores = (storeGroupQueryData)=>{
    if (!storeGroupQueryData) {
        return null;
    }
    try {
        return storeGroupQueryData.map(fromStoreGroupEntryToStore);
    } catch (e) {
        console.error('Store group query data adapter failed to parse input data correctly.', e, storeGroupQueryData);
        return null;
    }
};
const fromStoreGroupEntryToStore = (entry1)=>{
    const franchiseStory = entry1.storeTypes || [];
    var _rating, _slug, _storenote, _streetNumber, _additionalStreetInfo, _postalCode, _province, _lat, _lon, _email, _servicesNotAvailable, _specialOpenClosingHours, _storeDetailImage, _wheelchairAccessible, _weekendOpen, _hearingAppointmentPossible;
    return {
        code: entry1.code,
        globalStoreId: entry1.globalStoreId,
        name: entry1.name,
        shortName: entry1.name,
        streetName: entry1.streetName,
        town: entry1.town,
        country: entry1.country,
        rating: getRating((_rating = entry1.rating) !== null && _rating !== void 0 ? _rating : undefined),
        phone: entry1.phone,
        slug: (_slug = entry1.slug) !== null && _slug !== void 0 ? _slug : undefined,
        storeNote: (_storenote = entry1.storenote) !== null && _storenote !== void 0 ? _storenote : undefined,
        streetNumber: (_streetNumber = entry1.streetNumber) !== null && _streetNumber !== void 0 ? _streetNumber : undefined,
        additionalStreetInfo: (_additionalStreetInfo = entry1.additionalStreetInfo) !== null && _additionalStreetInfo !== void 0 ? _additionalStreetInfo : undefined,
        postalCode: (_postalCode = entry1.postalCode) !== null && _postalCode !== void 0 ? _postalCode : undefined,
        province: (_province = entry1.province) !== null && _province !== void 0 ? _province : undefined,
        lat: (_lat = entry1.lat) !== null && _lat !== void 0 ? _lat : undefined,
        lon: (_lon = entry1.lon) !== null && _lon !== void 0 ? _lon : undefined,
        emailAddress: (_email = entry1.email) !== null && _email !== void 0 ? _email : undefined,
        servicesNotAvailable: (_servicesNotAvailable = entry1.servicesNotAvailable) !== null && _servicesNotAvailable !== void 0 ? _servicesNotAvailable : [],
        appointmentsAvailable: entry1.appointmentsAvailable,
        openingHours: {
            monday: convertToValidOpeningHours(entry1.monOpenClose),
            tuesday: convertToValidOpeningHours(entry1.tueOpenClose),
            wednesday: convertToValidOpeningHours(entry1.wedOpenClose),
            thursday: convertToValidOpeningHours(entry1.thuOpenClose),
            friday: convertToValidOpeningHours(entry1.friOpenClose),
            saturday: convertToValidOpeningHours(entry1.satOpenClose),
            sunday: convertToValidOpeningHours(entry1.sunOpenClose)
        },
        specialOpeningHours: ((_specialOpenClosingHours = entry1.specialOpenClosingHours) !== null && _specialOpenClosingHours !== void 0 ? _specialOpenClosingHours : []).filter((entry)=>entry !== null
        ),
        storeDetailImage: (_storeDetailImage = entry1.storeDetailImage) !== null && _storeDetailImage !== void 0 ? _storeDetailImage : undefined,
        wheelchairAccessible: (_wheelchairAccessible = entry1.wheelchairAccessible) !== null && _wheelchairAccessible !== void 0 ? _wheelchairAccessible : undefined,
        weekendOpen: (_weekendOpen = entry1.weekendOpen) !== null && _weekendOpen !== void 0 ? _weekendOpen : false,
        hearingAppointmentPossible: (_hearingAppointmentPossible = entry1.hearingAppointmentPossible) !== null && _hearingAppointmentPossible !== void 0 ? _hearingAppointmentPossible : false,
        isFranchiseStore: franchiseStory.includes(FRANCHISE_STORE)
    };
};

export { fromStoreGroupEntryToStore, fromStoreGroupQueryDataToStores };
//# sourceMappingURL=adapters.js.map
